import React, { useState } from 'react';
import './Services.css';
import { useTranslation } from 'react-i18next';

const INITIAL_VISIBLE_COUNT = 3;

const Services = ({ servicesData }) => {
  const { t } = useTranslation();

  // Эта логика остается без изменений
  const [visibleCount, setVisibleCount] = useState(INITIAL_VISIBLE_COUNT);
  if (!servicesData || servicesData.length === 0) {
    return null;
  }
  const isExpanded = visibleCount === servicesData.length;
  const visibleServices = servicesData.slice(0, visibleCount);
  const handleToggleVisibility = () => {
    if (isExpanded) {
      setVisibleCount(INITIAL_VISIBLE_COUNT);
    } else {
      setVisibleCount(servicesData.length);
    }
  };

  return (
    <section id="services" className="services-section">
      <div className="container">
        <h2>{t('services.title')}</h2>
        <div className="services-grid">
          {/* ИЗМЕНЕНИЕ №1: Используем 'visibleServices' вместо 'servicesData' */}
          {visibleServices.map((service) => (
            <div key={service.id} className="service-card">
              {service.icon_class && (
                <i className={`service-icon ${service.icon_class}`}></i>
              )}
              {service.image_url && (
                <img src={service.image_url} alt={service.title} className="service-image" loading="lazy" />
              )}
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {service.list_item && (
                <ul className="service-list">
                  {service.list_item.split(';').map((item, index) => (
                    <li key={index}>{item.trim()}</li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>

        {/* ИЗМЕНЕНИЕ №2: Заменяем старую кнопку на новую логику */}
        {servicesData.length > INITIAL_VISIBLE_COUNT && (
          <div className="show-more-container" style={{ textAlign: 'center', marginTop: '30px' }}>
            <button onClick={handleToggleVisibility} className="show-more-button">
              {isExpanded
                ? t('services.showLessButton', 'Свернуть')
                : t('services.showMoreButton', 'Показать еще')}
            </button>
          </div>
        )}
      </div>
    </section>
  );
};

export default Services;